import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import UploadArea from './components/UploadArea';
import TemplateShow from './components/TemplateShow';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DataTables from './components/DataTables'
import MemeShow from './components/MemeShow'


const styles = theme => ({
  pageIndex: {
    maxWidth: theme.contentWidth.sub,
    width: '100%',
    marginBottom: 100
  },
  container: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },
  tabText: {
    fontSize: 18,
    fontWeight: 400
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3
  }
});

class PageIntro extends React.Component {
  state = {
    tab: 'latest',
  }

  changeTab = (event, value) => {
    this.setState({ tab: value });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.pageIndex}>
        <UploadArea />
        <MemeShow />
        <Paper className={classes.paper}>
          <Tabs
            value={this.state.tab}
            onChange={this.changeTab}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
            TabIndicatorProps={{
              style: {
                height: 3.5
              }
            }}
          >
            <Tab label="最新" value='latest' classes={{label: classes.tabText}} />
            <Tab label="常用" value='often' classes={{label: classes.tabText}} />
            <Tab label="全部" value='total' classes={{label: classes.tabText}} />
          </Tabs>
          {this.state.tab !== 'total' && <TemplateShow mode={this.state.tab} />}
          {this.state.tab === 'total' && <DataTables />}
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(PageIntro);


// WEBPACK FOOTER //
// ./src/PageIntro.js